import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  chipLow: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  chipMedium: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  chipHigh: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  selectedOptionsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  selectedOptionRow: {
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.shape.borderRadius,
  },
  alert: {
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 2),
  },
  alertHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  alertTitle: {
    fontWeight: 700,
    letterSpacing: 0.5,
  },
  alertDescription: {
    color: theme.palette.text.primary,
  },
  alertLow: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    '& $alertTitle, & $alertIcon': {
      color: theme.palette.statusLabel.success.primary,
    },
  },
  alertMedium: {
    backgroundColor: theme.palette.statusLabel.warning.secondary,
    '& $alertTitle, & $alertIcon': {
      color: theme.palette.statusLabel.warning.primary,
    },
  },
  alertHigh: {
    backgroundColor: theme.palette.statusLabel.error.secondary,
    '& $alertTitle, & $alertIcon': {
      color: theme.palette.statusLabel.error.primary,
    },
  },
  alertIcon: {
    flexShrink: 0,
  },
  optionItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    cursor: 'pointer',
    transition: 'border-color 0.15s, background-color 0.15s',
    userSelect: 'none',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '&$optionChecked': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
    },
  },
  optionChecked: {},
  optionReadOnly: {
    cursor: 'default',
    pointerEvents: 'none',
  },
  optionLabel: {
    lineHeight: 1.4,
  },
}))

export default useStyles
